const aboutCardsSlider = document.querySelectorAll('[data-slider="about-cards-slider"]');

if (aboutCardsSlider.length > 0) {
  const aboutCardSliderOptions = {
    slidesPerView: 'auto',
    spaceBetween: 20,
    watchOverflow: true,
    navigation: {},
  };

  const initAboutCardSlider = () => {
    aboutCardsSlider.forEach((el) => {
      const parentEle = el.closest('[data-slider-parent]');
      const arrowRight = parentEle?.querySelector('.arrow-right');
      const arrowLeft = parentEle?.querySelector('.arrow-left');

      if (windowWidth() > 767) {
        new Swiper(el, {
          ...aboutCardSliderOptions,
          navigation: {
            nextEl: arrowRight,
            prevEl: arrowLeft,
          },
        });
      } else {
        enableArrowScrollSync(parentEle);
      }
    });
  };

  setupResponsiveSliders({
    sliderElements: aboutCardsSlider,
    breakpoint: 767,
    initSlider: initAboutCardSlider,
    mobileFallback: enableArrowScrollSync,
    parentSelector: '[data-slider-parent]',
  });
}
